import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/5a1649/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const DoDontExample = makeShortcode("DoDontExample");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`To create is to generate a new resource. Creating is distinct from adding, but the two are often confused. To add a resource is to include a resource that already exists.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview/"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainer"
    }}>{`Maintainer:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Standard creation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Multistep creation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Confirmation</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "51.42857142857144%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABdUlEQVQoz5WS207CQBCG+4SGgxERKwl3akC44c6ESx8DTfRNaCUmPoAtKNS2hp5PthTK7+4iCAmQ2OTLzm5nvplsy9m2hVqtijOex8lpGblCgVEicYW/QOWc34aclco0r4g8pXiMo1yenFfheT64j5GCy+smREFAr9dDv98nPEMURbbfhUCg+QySJwik7uUVyTQFNxwO0W63QR/HcWCaJizLguu6WCwWyLLsl804w3w+/4PuZzMWM2Gr1UQURdC+TOiEycSAYRiwbZs1oI1WTTzP28uMSLnBYIBGo4E4TqCoOhTlE6qqMoFpWkzo+z7b0zUIgvW6CT1jQlmWUa/XkSQJxuMRJEmCLEsYym9Qxu9EaLDJwjBkRbtkW0I64Uqo6TqTavoE6iSEZkQkOVoX/GvCNE3R7d6jdXOF27sHdJ6m6DyGGOkBvqNg72R7J4zjmF0+/RCO48JxA8JqKroelu4ULl+G5L4ChERCWSYHTHpIRqG/zQ9YDcAR1La8ogAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example",
        "title": "Example",
        "src": "/static/80aa8368c5bdf3682f1bfef77073168f/fb070/1.png",
        "srcSet": ["/static/80aa8368c5bdf3682f1bfef77073168f/d6747/1.png 288w", "/static/80aa8368c5bdf3682f1bfef77073168f/09548/1.png 576w", "/static/80aa8368c5bdf3682f1bfef77073168f/fb070/1.png 1152w", "/static/80aa8368c5bdf3682f1bfef77073168f/fb104/1.png 1728w", "/static/80aa8368c5bdf3682f1bfef77073168f/8fefe/1.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of a creation pattern</Caption>
    <h2 {...{
      "id": "standard-creation"
    }}>{`Standard creation`}</h2>
    <p>{`Use the standard creation pattern when no stepped guidance is needed and the input fields are directly related to each other. This pattern applies to side panel, multistep, and full-page creation flows. You should also provide advanced options for the user.`}</p>
    <h3 {...{
      "id": "modal"
    }}>{`Modal`}</h3>
    <p>{`If there are only one or two decisions to be made during a creation, use a small, standard modal overlaying the content where the creation was initiated. Avoid scrolling inside a small modal.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.2663043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABRElEQVQ4y62Sy06DQBSGeQZr3OqqAaOo+8aWjTueoHtXXjYuulHjE7pxIw0mJsqtKVehlNvvzBAqtFIWOsmXfybM+TiHwBVFAbpo/oXKwVWbNmnXWr/H1WXbCrZ1Vr/H1R/4vg/btuE4DiMIAkRRhDAMW6E1WZb9jFwXmqaJ6XQKVVWhKArm8zkr8DyvFdd124W0K03ToOs6k9Nz1ckXI2oQsgw3hdVhsVis3hrHMdI0XZGlS2RJvEGyjJC3CS3LWnVnGAbblxj4tFxCAG3mN9BnAZL0FyEdS5ZliKIIQRDA8zx4kgLfR//wBPuXrziYAL2rFL3rHLs3OXZI7t3meH4vHVleE9Jxx+MxBoMBJEnCaDQqGZ5jKF3g7O4N4hNwfJ8TSD4ARyRPH4GXD9YfEaL5Y3evopVSsfYNu0Etm5QO/L/wG3lpyaoawmjhAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a standard creation modal",
            "title": "Example of a standard creation modal",
            "src": "/static/46ff0e6e3ed7966385a05f7b9ae59a43/fb070/2.png",
            "srcSet": ["/static/46ff0e6e3ed7966385a05f7b9ae59a43/d6747/2.png 288w", "/static/46ff0e6e3ed7966385a05f7b9ae59a43/09548/2.png 576w", "/static/46ff0e6e3ed7966385a05f7b9ae59a43/fb070/2.png 1152w", "/static/46ff0e6e3ed7966385a05f7b9ae59a43/c3e47/2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a standard creation modal</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "side-panel"
    }}>{`Side panel`}</h3>
    <p>{`If you have limited screen real estate, consider using a side panel. Side panels keep the user aware of the context in which they are working. You may choose to use either slide in or slide over panels.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.82142857142857%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABl0lEQVQ4y82Uz0sCQRTH/Vs9CaEexKT196o3vXS0g9QpyiUVCVx0XWVFCAQTSVG8y+rqYVsrcvzmjKy5rRHRpYEP8/YxfHjDvjcObNdms8Ffl+lwmMFgMIAkSWg2m2g0GkeRZRn1ep2do9BYFEV0u9291EEIYR+5XA5OpxNerxdut9uCx+OBy+VCNptFpVJBtVpFrVZjUirsdDp2YblcRiQSQTqdtpHJZJBMJtHv93++siksFAoIBAKIRqMIh8MWaM7v90NRFOi6DlVVMZvNGDSmOVuFxWIRHBdklfA8b4HmOI5Du93GarWCpmlYLpeMxWIBwzC+E3JIJBKIx+MWaO6rkIr+t/CXV+YtmMJWq/X5U+Ya5toS6nwB/fmIsFQqIRQKIZlKMcEhqW2OCnu9HjtLyLZF1i/Am7aDGNh1zYFQEAT4fD7WJsFg0AYVxmIxVnEsfIbQ+T1Ob4GTq1dcyO9MRlX70ZtOpxgOhxiPxxiNRjYmkwkbvXxewJ1wg7z4iOsH4FJZQ3oiO+FW5fjb40DMOWEyun8APJWrJcSk8h0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a side panel creation flow",
            "title": "Example of a side panel creation flow",
            "src": "/static/257567e21a2d4c1f4b9b39050580eabd/fb070/3.png",
            "srcSet": ["/static/257567e21a2d4c1f4b9b39050580eabd/d6747/3.png 288w", "/static/257567e21a2d4c1f4b9b39050580eabd/09548/3.png 576w", "/static/257567e21a2d4c1f4b9b39050580eabd/fb070/3.png 1152w", "/static/257567e21a2d4c1f4b9b39050580eabd/fb104/3.png 1728w", "/static/257567e21a2d4c1f4b9b39050580eabd/8fefe/3.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a side panel creation flow</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "full-page"
    }}>{`Full page`}</h3>
    <p>{`If your creation flow consists of multiple fields and/or supporting imagery, consider the full-page option. Full-page creation flows allow you to take advantage of maximum screen real estate.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.74999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABfUlEQVQ4y62TzWvCQBDF/f9BUbGmLXjoVWoPvejJg0YJ7amXIhQx2kQUNd8xMZq8ZkY2GGulBxdednZ298e8YVNIkgS3HAX6dDod1Go1NBoNVCoVFItFlEqlf6lcLqNarUKSJDiOcwSORiN0u128v71DURQMh0MMBgPIspyTyPV6vaP6MvpymkvzdC8MQxTIMimKIiyWCxiGwdrtdpyP4zjT4XC4YJJytBfzea5wu93CNExMphNocx3LxRKmacK27UyWZcHzPKjqFM1mE8+tF7z252jJPj6+bPiew1AGBkHAAHWiQtd0fGsaVqsV1us1z1Qx9YfOjcdj1Ot3kO4f8dTW8dAOoHw6CAM3D6Qq6KLv+9wLqppiApFc1+WZ8tlI/NStgyikMy635ReQbNGaJIACJmZyw7LS2HLTu8e9i0CCnANPYSI+lcjlgJSkxgvLwjZVfA74SzkgWZjNZthsNhyL5yPWorpryoD7/Z4ro8vn1mg+rfqa+B3e+l/+AWEjy5lsp1IyAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full-page creation flow",
            "title": "Example of a full-page creation flow",
            "src": "/static/eebc9840c3726010dcc393d9e69c96a1/fb070/4.png",
            "srcSet": ["/static/eebc9840c3726010dcc393d9e69c96a1/d6747/4.png 288w", "/static/eebc9840c3726010dcc393d9e69c96a1/09548/4.png 576w", "/static/eebc9840c3726010dcc393d9e69c96a1/fb070/4.png 1152w", "/static/eebc9840c3726010dcc393d9e69c96a1/fb104/4.png 1728w", "/static/eebc9840c3726010dcc393d9e69c96a1/8fefe/4.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.74999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABaUlEQVQ4y62Ty07CQBSGeXiMGhNKCo3phg3ElUbjQmKANqgLn4DEJawglEtv3Er7M/9pihQXYEKTr505c+abMzNQSJIEl3wKfLVaLRiGgVqthkqlAk3TUC6X5XtIqVSSOHNJVddwb6h+VYdpmvB9PxX2ej20223Btm10u12B7U6ns8eyLDSbTdTrdUUDD4/vaDzZeH2z8PX5geVymQq57e12i9Vq9WcLcRwLHOfT7/dxVSzi+uYO+rOD2xfg+ydmpspLUuFiscB8Psd0OpWywzAU2HZdN4fneZJPwkC1Axe+p8ZUnAuLkKUymcIgCH4nKCkFGVzgsJ/i78dyQgZZJUXr9Vpgm4mZ6Gwhz242m2E4HMJxHIzHY4EVM86FDmXZIseL5SrkxMFgINLRaCRMJhMhO9t/CRmklNvcbDayZcZ5puRYclLIS+F2OcA+4aVkN3uKnJAV8RwpYWVRFAlZ/Bw4j7/nwqX/yzsmjM0zih7qOwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full-page creation flow",
            "title": "Example of a full-page creation flow",
            "src": "/static/1a6bb48949e46d30512a69163e1f35b3/fb070/5.png",
            "srcSet": ["/static/1a6bb48949e46d30512a69163e1f35b3/d6747/5.png 288w", "/static/1a6bb48949e46d30512a69163e1f35b3/09548/5.png 576w", "/static/1a6bb48949e46d30512a69163e1f35b3/fb070/5.png 1152w", "/static/1a6bb48949e46d30512a69163e1f35b3/fb104/5.png 1728w", "/static/1a6bb48949e46d30512a69163e1f35b3/8fefe/5.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a full-page creation flow</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "multistep-creation"
    }}>{`Multistep creation`}</h2>
    <p>{`If the creation task is complex, consider breaking the process up into multiple steps. Display related or dependent options together.`}</p>
    <p>{`Multistep creation follows the same principles as standard creation but the creation takes place through several steps. This flow can take place in a side panel or can use the full display.`}</p>
    <h3 {...{
      "id": "side-panel-multistep"
    }}>{`Side panel multistep`}</h3>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.13586956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAABnElEQVQ4y92TS0sCURTH/aYtFUIhKZeC+AIfC0VT85Ghhm5cSQslkNGywixXfoFWOY9MzYqO/+65PQwtiGrVwG+G84f7O2dm7jXhD6/5fA4T36rVKmKxGFKpFJLJ5Jek0zvI5XLIZDLvZLNZJBIJ1Go1KZXCUCgEs9kMm80Gq9W6AucWiwWx+DZa7WOcnJ7hvHeBbvccvV5PPLsYDAYLYblcltJoNIpIJLIC56FgAE3l6HuvXCgU4PV6EQwGEQgEVuDc4/Gg0WhgdjeFruu4MQwYr3A9nU4XE7LQ5/PJKXnxMpxzQxaOJxNomiYlb3A9EfmPhJNXofFXE34m5PqfCuv1OkajEYbDIVRVharpAgPXqo7b8QdhsViE3+9HOByWi5fhnBu2Wi25iIjknsPDSKAB94KnxV8mcZzI6XSS2GvkdrtX4NzlclE8HqdKpULFUon2SwXaO7ymnPJEqcMZHVw+EvcysbXf76PZbKLdbsspllEUBZ1OB/l8Hna7HVsOBxybG1jPqrDsA2u7QLjxclpYePU7SDCXiK9w9Qzs8NAK06MeigAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of side panels in a multi-step creation flow",
            "title": "Example of side panels in a multi-step creation flow",
            "src": "/static/21452a9eb23323a6c26efdd8b73f17f0/fb070/11.png",
            "srcSet": ["/static/21452a9eb23323a6c26efdd8b73f17f0/d6747/11.png 288w", "/static/21452a9eb23323a6c26efdd8b73f17f0/09548/11.png 576w", "/static/21452a9eb23323a6c26efdd8b73f17f0/fb070/11.png 1152w", "/static/21452a9eb23323a6c26efdd8b73f17f0/c3e47/11.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "71.05978260869566%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABhElEQVQ4y+WTy07CQBSGeTPfwMTExLJmQWAvkS23Fspl4wsQWOAj2AYjIUFcutLgxsQVvdML9P7bGSBEQeNlaZOvM53JfDM9Z04qjmM4jgPTNGFZ1pcYhgFVVSmKsmbdV7BYLECeFBHW63VkMhnk83nkcrmDZLNZFIsXaDb5hCba7RY6hE4bHMdhMBjshN1uF+VymYrJ5EfIeKlUwrUgwnI8LN0AfgQ4bgQ/BMUjr8RFhf1+HyzL0p15nt+j1WqhWq1iOLxBGMZYrVysXA+Gudz0Xfh+sDthr9dDrVajixuNxh5kIyIURRG2bdGYaZoGXddoq6pKMm7vCz874XuhTROh63oi0zetRhP7Z+EW8v3PhL+OoSAItCJkWaaZVhQNiqpBklWY1g+zXKlUMBqN6KIgCBBFEWLPTDAQuzoQLr9/D7d3sVAogGEYMOk00menOOFecHwJHLEhzq+S0sGmUkgM5vM5JEmi7SHIb85mM0wmE0yn9wl3GD86GD8Dt08xHl5BhW8CNIQ5nfxgmwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ExampExample of a side panel multi-step creation flow",
            "title": "ExampExample of a side panel multi-step creation flow",
            "src": "/static/0127e28c6b1cb50c8fbd5dd3a113dfbb/fb070/12.png",
            "srcSet": ["/static/0127e28c6b1cb50c8fbd5dd3a113dfbb/d6747/12.png 288w", "/static/0127e28c6b1cb50c8fbd5dd3a113dfbb/09548/12.png 576w", "/static/0127e28c6b1cb50c8fbd5dd3a113dfbb/fb070/12.png 1152w", "/static/0127e28c6b1cb50c8fbd5dd3a113dfbb/c3e47/12.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a side panel multi-step creation flow</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "full-page-multistep"
    }}>{`Full page multistep`}</h3>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.141304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABV0lEQVQoz6WSz0vDMBTH+9fvF4iFnTwI4kRBEMGLN2UHb/tBmTvUg9s6xDrn0r6kpl07viYZLWxjP9TApy+U5PPykmdxzuE4Dnq9nontdtvQ6XT2kq/rdrsmapfleR6q1Sps20a9Xke5XDaUSqWDqFQqqNVqxqFdFtRYLBaIYwkpJebzueGvw0rTFEQE3/cxGI5UljHGKlMQBL9Gu5QwgxAc/mcA/2OGrxlDGIZmwWQyMfPpdGqiviOdfBtZli1PGEWRqb/ff4brungdDM1p39WptTjfkAt1XKcQ6g/R8qcQQskFaPYGST4EZ2AsWNm0TVoI9QMkSYJmswn7+AinZ1doPEic3Eu4nkSaRKpc2pDuFMZxjFarhYvGOa5v7nD7xHH5yPEyIsiIEBJfKfuAksm8UDEyUr1EiL95cR372BDqy2eMLQnIoEvd9arrmLbRTZ0383/Rrh/DK3dWZIzxnAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Multistep creation flow with image",
            "title": "Multistep creation flow with image",
            "src": "/static/4f4020365cd06e775100c03e57fb0cc7/fb070/13.png",
            "srcSet": ["/static/4f4020365cd06e775100c03e57fb0cc7/d6747/13.png 288w", "/static/4f4020365cd06e775100c03e57fb0cc7/09548/13.png 576w", "/static/4f4020365cd06e775100c03e57fb0cc7/fb070/13.png 1152w", "/static/4f4020365cd06e775100c03e57fb0cc7/c3e47/13.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.141304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABcElEQVQoz6WSy07CQBSG+7AmunPlxoUbAwRWJOxcu8bXcAOEIG4g2BulV+iFtpSW/Mw5WKVqkGiTL2eaOfPN35lKURRhOBxiNBpx7fV6TL/fP5vBYMA1DENIqqqi2Wyi3W6j0+mg0Wgw9Xr9V2q1Gve2Wi12yLIMCeLZ7XbYbFKkaYLtdsv89ZHyPOeoC9PEm6xAVTWBDt/3EQj8LyyXSziOA9d1Ge4LAq7kkvKiAJ2j4/mwbA+GtcLC8uB5K9i2zY20kBZRH1UKUEoKsT7LMn6nMSeM4xiapmE8fsF0OsVsNoNhGAzJSEQSIk1TfB7Thsd0RBXher2GruuYTCYH0VzDXFfFJioURRFpPe4hIW1ONUkSptyEakVoijOklKZlw/JimG6CIErEHH1m+C3lMaWYhRSXBt3uE64uL3Bze4+7xxjXDzGeXyPkGQkPsmPpT/ClFO+XUp2MPqC5c6gIS9GxODqR5GRCuq3yZ/4v5NoDOB53Op1xjGMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Multistep creation flow with image",
            "title": "Multistep creation flow with image",
            "src": "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/fb070/14.png",
            "srcSet": ["/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/d6747/14.png 288w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/09548/14.png 576w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/fb070/14.png 1152w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/c3e47/14.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.141304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABT0lEQVQoz62S3U7CQBCF+8SYGLz2ihK4IuFaH8C38AEoIST0AhNLJdjSpd3ugkBLOe5M5UfUCNFNvpxtZnvmzGYtrTV6vR76/T5rp9NhHMc5m263y6qUguX7PhqNBlqtFtrtNur1OmPb9o/UarU9dLbZbLKH53mwYFZRFFitllgu35Bla0OGS9d2W6qV5zlHfQ0CPHsjjPwXJk6kIWWVsiRNU0RRxEloMn8SYzRJEURUkyAva7PZgO5RzCSC6QxTU4xEglBQE2EMFYQQSJKEk9P9VipXuKlWcXvv4fpujYdHhXylsM7yMuFiscB4PIY7GMB1XTwNh5yAkoRhyBMQ1JhSxnHMJFKZhhoy1dCm/ikhJaBx6AeCvmnM2OjObKfz+byE9vpQ2xt+OWig1ATtj812aQ/oD04Mf+PY9DvU6ch/5eKE58CG9KjpOfwH5PUO+WZ3DLbrD3cAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Multistep creation flow with image",
            "title": "Multistep creation flow with image",
            "src": "/static/58c24100409234a80097a2a5c6a7b24d/fb070/15.png",
            "srcSet": ["/static/58c24100409234a80097a2a5c6a7b24d/d6747/15.png 288w", "/static/58c24100409234a80097a2a5c6a7b24d/09548/15.png 576w", "/static/58c24100409234a80097a2a5c6a7b24d/fb070/15.png 1152w", "/static/58c24100409234a80097a2a5c6a7b24d/c3e47/15.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Multistep creation flow with image</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "full-page-multistep-with-image"
    }}>{`Full page multistep with image`}</h3>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.141304347826086%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABV0lEQVQoz6WSz0vDMBTH+9fvF4iFnTwI4kRBEMGLN2UHb/tBmTvUg9s6xDrn0r6kpl07viYZLWxjP9TApy+U5PPykmdxzuE4Dnq9nontdtvQ6XT2kq/rdrsmapfleR6q1Sps20a9Xke5XDaUSqWDqFQqqNVqxqFdFtRYLBaIYwkpJebzueGvw0rTFEQE3/cxGI5UljHGKlMQBL9Gu5QwgxAc/mcA/2OGrxlDGIZmwWQyMfPpdGqiviOdfBtZli1PGEWRqb/ff4brungdDM1p39WptTjfkAt1XKcQ6g/R8qcQQskFaPYGST4EZ2AsWNm0TVoI9QMkSYJmswn7+AinZ1doPEic3Eu4nkSaRKpc2pDuFMZxjFarhYvGOa5v7nD7xHH5yPEyIsiIEBJfKfuAksm8UDEyUr1EiL95cR372BDqy2eMLQnIoEvd9arrmLbRTZ0383/Rrh/DK3dWZIzxnAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Multistep creation flow with image",
        "title": "Multistep creation flow with image",
        "src": "/static/4f4020365cd06e775100c03e57fb0cc7/fb070/13.png",
        "srcSet": ["/static/4f4020365cd06e775100c03e57fb0cc7/d6747/13.png 288w", "/static/4f4020365cd06e775100c03e57fb0cc7/09548/13.png 576w", "/static/4f4020365cd06e775100c03e57fb0cc7/fb070/13.png 1152w", "/static/4f4020365cd06e775100c03e57fb0cc7/c3e47/13.png 1472w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Multistep creation flow with image</Caption>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.141304347826086%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABcElEQVQoz6WSy07CQBSG+7AmunPlxoUbAwRWJOxcu8bXcAOEIG4g2BulV+iFtpSW/Mw5WKVqkGiTL2eaOfPN35lKURRhOBxiNBpx7fV6TL/fP5vBYMA1DENIqqqi2Wyi3W6j0+mg0Wgw9Xr9V2q1Gve2Wi12yLIMCeLZ7XbYbFKkaYLtdsv89ZHyPOeoC9PEm6xAVTWBDt/3EQj8LyyXSziOA9d1Ge4LAq7kkvKiAJ2j4/mwbA+GtcLC8uB5K9i2zY20kBZRH1UKUEoKsT7LMn6nMSeM4xiapmE8fsF0OsVsNoNhGAzJSEQSIk1TfB7Thsd0RBXher2GruuYTCYH0VzDXFfFJioURRFpPe4hIW1ONUkSptyEakVoijOklKZlw/JimG6CIErEHH1m+C3lMaWYhRSXBt3uE64uL3Bze4+7xxjXDzGeXyPkGQkPsmPpT/ClFO+XUp2MPqC5c6gIS9GxODqR5GRCuq3yZ/4v5NoDOB53Op1xjGMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Multistep creation flow with image",
        "title": "Multistep creation flow with image",
        "src": "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/fb070/14.png",
        "srcSet": ["/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/d6747/14.png 288w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/09548/14.png 576w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/fb070/14.png 1152w", "/static/8f6b4dd3aca423b3ad0fdd844b6e09d5/c3e47/14.png 1472w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Multistep creation flow with image</Caption>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.141304347826086%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABT0lEQVQoz62S3U7CQBCF+8SYGLz2ihK4IuFaH8C38AEoIST0AhNLJdjSpd3ugkBLOe5M5UfUCNFNvpxtZnvmzGYtrTV6vR76/T5rp9NhHMc5m263y6qUguX7PhqNBlqtFtrtNur1OmPb9o/UarU9dLbZbLKH53mwYFZRFFitllgu35Bla0OGS9d2W6qV5zlHfQ0CPHsjjPwXJk6kIWWVsiRNU0RRxEloMn8SYzRJEURUkyAva7PZgO5RzCSC6QxTU4xEglBQE2EMFYQQSJKEk9P9VipXuKlWcXvv4fpujYdHhXylsM7yMuFiscB4PIY7GMB1XTwNh5yAkoRhyBMQ1JhSxnHMJFKZhhoy1dCm/ikhJaBx6AeCvmnM2OjObKfz+byE9vpQ2xt+OWig1ATtj812aQ/oD04Mf+PY9DvU6ch/5eKE58CG9KjpOfwH5PUO+WZ3DLbrD3cAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Multistep creation flow with image",
        "title": "Multistep creation flow with image",
        "src": "/static/58c24100409234a80097a2a5c6a7b24d/fb070/15.png",
        "srcSet": ["/static/58c24100409234a80097a2a5c6a7b24d/d6747/15.png 288w", "/static/58c24100409234a80097a2a5c6a7b24d/09548/15.png 576w", "/static/58c24100409234a80097a2a5c6a7b24d/fb070/15.png 1152w", "/static/58c24100409234a80097a2a5c6a7b24d/c3e47/15.png 1472w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Multistep creation flow with image</Caption>
    <h3 {...{
      "id": "confirmation"
    }}>{`Confirmation`}</h3>
    <p>{`When any create action is a success, a notification banner can be presented to visually confirm this.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "74.32065217391305%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQ4y62Ty06EMBSGeX4uSza8h8lsjLN0YUwMO41hHG4ZShmH+/23p5iwUHSY0OSjJO3/cU5KFWw8lLZtYVkWVFWFruvQNO0qaK9hGBLKmqaJNE2hjOMI3/fhOA6CIEAYhnJe4hSe8HywcWffY/fygJ29x/79EU+ejbbroFCZVCXnHE3ToO97dGJhiaEfwOoz3tIjXpMDnNzDRxUiGs5Ty/TIsgye50lc1/0XX+wLfNGNgGbv6OLyeZmFVVUhjmMkSXIVnBAdScR7LOaiLGZhWZZgjEnpLVC2KH4Tii+tForMopDfIOR/CTessNq2QjplxqbFeCVSKMQ/Wo6i6PvE1kEZyuZ5PgvphtA9pB88XYnMiGxd15OQ7vJWg1xfnapjwFnfMvcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of a successful creation confirmation\"",
        "title": "Example of a successful creation confirmation\"",
        "src": "/static/28ca29d6e3a3f90464eceee38db4b9a8/fb070/16.png",
        "srcSet": ["/static/28ca29d6e3a3f90464eceee38db4b9a8/d6747/16.png 288w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/09548/16.png 576w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/fb070/16.png 1152w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/c3e47/16.png 1472w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of a successful creation confirmation</Caption>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <h3 {...{
      "id": "button-position"
    }}>{`Button position`}</h3>
    <p>{`When viewed on mobile, the buttons are positioned at the bottom of the screen.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "108.125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAAAsSAAALEgHS3X78AAAB1UlEQVQ4y7WUS0/CQBSF+dH+AFONBhZEEhIICIIkblgYlxZ3Lkhk6dalwfAQ2vIqtPTYM3jJAKWAiZOctJ3p/ea+ZhLQRhAE+MvQ7RIysVwu1USz2USxWEStVkO1WkWlUlHPcrmMUqm0oXq9Dt/3N6A7wEbjBYZhIJfLIZ/PI5PJIJvNIp1OI5lMIpVKrcWNPc/bBf5LyDK5WCzQ6/UwGAzQ7/cxmUzUGkNjFHzqErudkPWF6XQK27YxHo9VSPP5fC1uqNtEArehruvCsiyMRiP1TihFmF6EqBTtBdJDitDZbLbh4bZXB4EEOI6zIYIo6YZ9BYwNWUQg80rpbXJSyIQwRMmd5DEu3B2gPAnU88ZveT8ZyCqyEJKrqCbe1zKxIbOxCdY9i/Jqey4Rtbs+6Cmle3O0hwKgd51OB91uV3kpFeYxFMkpOgrIViF0OBwqIL8JJ0T6kk3PVBwFJITGBBJMtb++fi+Mb1j2GIOhA3e+OB5IKVC7rVqI857nw51Y4V9OaGCHCou1Mo4H6mGxqU3ThHFxidS1gavCM86fgLOHKZofq4vCXwbxjS3nVnLUarVQvC3h/q6A8uMbCq/AjRng/VNZQG/Zgzd29IkQQghbxbxe+QH/bqGVWa8gVQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Button position in context.",
            "title": "Button position in context.",
            "src": "/static/04f1a22edabef3458f50fc7be6632c20/fb070/6.png",
            "srcSet": ["/static/04f1a22edabef3458f50fc7be6632c20/d6747/6.png 288w", "/static/04f1a22edabef3458f50fc7be6632c20/09548/6.png 576w", "/static/04f1a22edabef3458f50fc7be6632c20/fb070/6.png 1152w", "/static/04f1a22edabef3458f50fc7be6632c20/fb104/6.png 1728w", "/static/04f1a22edabef3458f50fc7be6632c20/8fefe/6.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of full-page option on mobile</Caption>
      </Column>
    </Row>
    <p>{`On a larger screen, buttons should always remain visible to the user.`}</p>
    <p>{`If a display is likely to extend beyond the visible display, buttons should remain visible and should stick upon scrolling. If only a few buttons are present, they can be placed on the left below the last field.`}</p>
    <Row mdxType="Row">
      <Column colMd={4} colLg={6} mdxType="Column">
        <DoDontExample caption="Buttons should not be hidden off-screen." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABnUlEQVQ4y8WUi07CMBSGef9nEASDYGDgMwgaEy5eGGxM5DYBgTHYxmUbcftdi8CGk0RcYpMvO03br6frJYSASyhwoW3bNCBfy7JOwu0IbYO/lq1jl6GmaiiViyiUyg4lPDw+ocJW8VxhvbAsbSsUS7QfQdO0fYa2bdHKcDDAZfwM4VgU4UgU8UQS6UwWqTSDFMMgzWTAOPVM9hqJ5BUi0RjOYxeU9+HQLdxkuFqtIIpvkMZjSNIY49EII6cjxYl7vR5arRba7RY67Ta63Q66nQ26rn8XzudzNJuvmCkKZrMZRfmKVWdJRFitVsHzPDiO87BYLPyFJAPFJdyiqioVksH1en0HkROWy+Vx4aE0MOFuyUEI3WJyLPr9PhUKguCREnyFZFCj0YAsy5hMJpjIU4o8nVKxKIpgnTNYq9U8kI3y3RTTNB2puj/6luGgwzR0GIZBJ5QkaTPZAev12v/qKYqKXO4G+bt73L5YyDcAdXXC1XP/R46rgeMF8P0PcANgYZC2TZ9jeDL8+YHYdvzle+j7hJHYdrf91wMbtPATpkj5nJpHsxwAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Buttons should not be hidden off-screen.",
              "title": "Buttons should not be hidden off-screen.",
              "src": "/static/05e6c3673f6ed591b5aa2526d3a0aba4/fb070/7.png",
              "srcSet": ["/static/05e6c3673f6ed591b5aa2526d3a0aba4/d6747/7.png 288w", "/static/05e6c3673f6ed591b5aa2526d3a0aba4/09548/7.png 576w", "/static/05e6c3673f6ed591b5aa2526d3a0aba4/fb070/7.png 1152w", "/static/05e6c3673f6ed591b5aa2526d3a0aba4/c3bf2/7.png 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={6} mdxType="Column">
        <DoDontExample type="do" caption="Buttons are located on the left if they are likely to be visible when the page loads." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABnElEQVQ4y+WUWU/CQBSF+bEqxgd/jonvLALK5ktfWEQJUJ9MgKKBlrJEDNAWCjSsx7mDbCJGxQcTm3y5J525Z27nztSGX35sf99wNptxQXEymayYTjHdAY2tz133sC3Evs/CY1mhrulIJCKI3sQRicVxe5dEWrxHKiMizaCYSme4pjGaE43P52qatqpwYfjSaMDrdcDhdsPhdMPju0QgGII/EOSQDobCCIWv4bvyw+W+gOvCAyeLDZa7ZTgYDFCpVtFutzmtVgvNZpNDul6vQy6VoMgyFEVBuVx+Q4FlDbYNTdNEiSUYhrFFt9tFrVZDLpeDJEnI5/Mb9Hq9jw1ltrqu61t0Oh1uSMmFQmEDWmCnIVVIGzzHmLOPoaqq7FzRGRtjYukMDWZX559Me/gtQ8uyIIoinE4H66AXrtgzXPEWHqQKqpUyisUiT/6y4XA4hCAIODo8gP3kFMdnKuznTQjJRzxJWWRZQ94349OmjEYj9Pv91dEf6WwVDX2TOt3h+0gdp7gOvRuPx7uvHmkO6X2u3tLoh2xU+L9+sK94B/P/dIZSkAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Buttons are located on the left if they are likely to be visible when the page loads.",
              "title": "Buttons are located on the left if they are likely to be visible when the page loads.",
              "src": "/static/fcba1be25f32d330b0ad097cb156304f/fb070/7.7.png",
              "srcSet": ["/static/fcba1be25f32d330b0ad097cb156304f/d6747/7.7.png 288w", "/static/fcba1be25f32d330b0ad097cb156304f/09548/7.7.png 576w", "/static/fcba1be25f32d330b0ad097cb156304f/fb070/7.7.png 1152w", "/static/fcba1be25f32d330b0ad097cb156304f/c3bf2/7.7.png 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colMd={4} colLg={6} mdxType="Column">
        <DoDontExample type="do" caption="Buttons located on the right should stick upon scrolling so they are always visible." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABaklEQVQ4y+WUy07CQBhGeUwXGHkjl4SNQsJFUBDqmlBABUylBEs7dgUrWhYUaLuAQj87hUqxaIgYY+IkJzOdf3ryzfQSwg+30N8X2rbtDmi/XC63rFZYfQKt+df6HSFvcGzzHO8JtbGGWq2MMsuiXGFRv39As/WERrOFRmsNveae23h05qpV1lnPouKsH2vaNqEnVBUFuVwK6WwW6cwVrvMFlJg7FEvMGoZB4baIZCqNi3gCscsMYokbxJNZqKoaFJqmieFQcXvDMKDrOmazmYvuMBqp4DgOkcgZwuFTRM5lnERt5OsKYJmwPwrpjf1+H5PJBJqzBT90jtYEQUCn0wHP8+C7ItpdghdBdEIYwYQ00WAwwHQ6DQjpHK2JoghZlte8EgcJhEjurr4tlCRpA9lwpJAQssPBQnpu3nl+JaTsFR76UKjUT6/Xc9+KgHCxWLgp5/P5XmjNn9yPZVm/8OnR/hh2Ev6vH+wbEE34aTQ0QH8AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "White overflow menu on Gray 10 card.",
              "title": "White overflow menu on Gray 10 card.",
              "src": "/static/5a227d835b1628f5240bf36a929ea86f/fb070/7.8.png",
              "srcSet": ["/static/5a227d835b1628f5240bf36a929ea86f/d6747/7.8.png 288w", "/static/5a227d835b1628f5240bf36a929ea86f/09548/7.8.png 576w", "/static/5a227d835b1628f5240bf36a929ea86f/fb070/7.8.png 1152w", "/static/5a227d835b1628f5240bf36a929ea86f/c3bf2/7.8.png 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
      <Column colMd={4} colLg={6} mdxType="Column">
        <DoDontExample type="do" caption="If an illustration or image is displayed on the right then buttons should be displayed above the image." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABkklEQVQ4y+WUy07CQBSGeUoXksATuXXBRkDlJgbwDaB4gxI20LSoAZoYwAC9J1za/s4pKRSILMQYEyf5M2dOZ77zz0zbEH64hf4+0HVdL6DecWzYjgPbdlh8WDTHV5AR8oNjm89YO1QVBdX7MspcFeUKh4fHJ9T5Bmp1fiOeR6PZxHOtDq7KsfkcKhwHRVU3Dn3gaDBENpvEVTqNq+sUcjd5FEt3KBRLa90WCkhlMognkohdpBBL5BC/TGM4HO4DLcvCgEEt04RpGDB0HbqmrcTij9EIPHMYjURwGg4jeibi5NxGvjIAbAvuLpAW9Xo9qMy+wrYfFOXoWbvdhiiKkCQJ0qsM8e0dgvgC0zT2HRrMVb/fh8Yc7QIpR8BOp+PNI+maynaiQZb73vhbQHJG48lkgvF47DmnNUcBCTSdTj0RmPJfAmVZXgOpun+elKNigiCszi8gOlO6UBy6FKruu6OYct1uF61Wy7uYXZnszdgDLhYLz+V8PsdsNtsS5ahgsFBQy+XyFz496o/RlsP/9YP9BJUw/J3NkR7CAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "If an illustration or image is displayed on the right then buttons should be displayed above the image.",
              "title": "If an illustration or image is displayed on the right then buttons should be displayed above the image.",
              "src": "/static/636fc42f6e0a577572388a8e0e325163/fb070/7.9.png",
              "srcSet": ["/static/636fc42f6e0a577572388a8e0e325163/d6747/7.9.png 288w", "/static/636fc42f6e0a577572388a8e0e325163/09548/7.9.png 576w", "/static/636fc42f6e0a577572388a8e0e325163/fb070/7.9.png 1152w", "/static/636fc42f6e0a577572388a8e0e325163/c3bf2/7.9.png 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
    </Row>
    <h4 {...{
      "id": "including-an-image"
    }}>{`Including an image`}</h4>
    <p>{`When including a supporting image, place it on the right-hand side of the window.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.597826086956516%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABWklEQVQoz62T3U7CQBCFeWQfAC4akYAPoo/gUyhR4YaExFICNfSPdrfd/h4702xdFAMXbjLZ2Z3Tr3tm20HTNPivQawBJS/zOYbDIabTKSaTCcbjMSzL4r1LMRqNOJbLJUMZKKTEarXCer2GbdtwHAfb7RabzYbzc0F1c52maQfUlquqgmzBWZZdtCaEQBRFDCnL8tSyBhKMREmSsCjPcxRFwVHXNYspqOb7Pg6HA/buJ8IobsHZeSAJlVL8kA4Cao2pJZ0SPtJoh1KJ38AgCLgXNBPYdV14nsdrAmsd7c9m97i7tWA9Orh5qPD0WnRtqw0g9U6mEkXZ2aQTaMvaLg3qG93oYvGOtw+FZxvYhXw+kKQHhmHIfZGJwPF45JPRHMcxX5hp+cfX18No7oEqU/CjAF4asoYuQocJovy7RjlOetwDm7aSt3Zlmf35F1wzBufE5hvN/l0D/QJYSY3pZNn/sQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of supporting image placement.",
            "title": "Example of supporting image placement.",
            "src": "/static/a1ec96eb95b988100b6f8b189bbb799b/fb070/8.png",
            "srcSet": ["/static/a1ec96eb95b988100b6f8b189bbb799b/d6747/8.png 288w", "/static/a1ec96eb95b988100b6f8b189bbb799b/09548/8.png 576w", "/static/a1ec96eb95b988100b6f8b189bbb799b/fb070/8.png 1152w", "/static/a1ec96eb95b988100b6f8b189bbb799b/c3e47/8.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of supporting image placement</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "advanced-option"
    }}>{`Advanced option`}</h3>
    <p>{`Have a minimal set of options visible by default and give a user the option to expose more advanced options. If the user switches to advanced mode, remember this next time they perform the same task.`}</p>
    <p>{`The advanced option allows advanced users to access all options without overwhelming typical users. It can be applied to the side panel and the full-page dialog.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "33.016304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAAd0lEQVQoz52R0QqAIAxF/f8/DH1KwXrooWkYlN6yIERMssHYdjmMO8aQRAjhqbVMmTxYLpSgFoaVQO89iAg0E9ziYK295zONMd8dpgvHYUTHO4heQGsNKSWUUlffvDDWfdthVgs+if8nv8FRi66bn/L25VyruTwA8VAppjU90OcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of advanced option",
            "title": "Example of advanced option",
            "src": "/static/ce20748a9a1961a5181598a2abc0d433/fb070/9.png",
            "srcSet": ["/static/ce20748a9a1961a5181598a2abc0d433/d6747/9.png 288w", "/static/ce20748a9a1961a5181598a2abc0d433/09548/9.png 576w", "/static/ce20748a9a1961a5181598a2abc0d433/fb070/9.png 1152w", "/static/ce20748a9a1961a5181598a2abc0d433/c3e47/9.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of advanced option</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "confirmation-1"
    }}>{`Confirmation`}</h3>
    <p>{`When any creation is successful, a notification banner should be presented to visually confirm the action.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.32065217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQ4y62Ty06EMBSGeX4uSza8h8lsjLN0YUwMO41hHG4ZShmH+/23p5iwUHSY0OSjJO3/cU5KFWw8lLZtYVkWVFWFruvQNO0qaK9hGBLKmqaJNE2hjOMI3/fhOA6CIEAYhnJe4hSe8HywcWffY/fygJ29x/79EU+ejbbroFCZVCXnHE3ToO97dGJhiaEfwOoz3tIjXpMDnNzDRxUiGs5Ty/TIsgye50lc1/0XX+wLfNGNgGbv6OLyeZmFVVUhjmMkSXIVnBAdScR7LOaiLGZhWZZgjEnpLVC2KH4Tii+tForMopDfIOR/CTessNq2QjplxqbFeCVSKMQ/Wo6i6PvE1kEZyuZ5PgvphtA9pB88XYnMiGxd15OQ7vJWg1xfnapjwFnfMvcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a successful creation confirmation",
            "title": "Example of a successful creation confirmation",
            "src": "/static/28ca29d6e3a3f90464eceee38db4b9a8/fb070/16.png",
            "srcSet": ["/static/28ca29d6e3a3f90464eceee38db4b9a8/d6747/16.png 288w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/09548/16.png 576w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/fb070/16.png 1152w", "/static/28ca29d6e3a3f90464eceee38db4b9a8/c3e47/16.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a successful creation confirmation</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      